import { render, staticRenderFns } from "./AddRuleDialogV2.vue?vue&type=template&id=68de53c1&scoped=true"
import script from "./AddRuleDialogV2.vue?vue&type=script&lang=js"
export * from "./AddRuleDialogV2.vue?vue&type=script&lang=js"
import style0 from "./AddRuleDialogV2.vue?vue&type=style&index=0&id=68de53c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de53c1",
  null
  
)

export default component.exports